export default "__VITE_ASSET__Dg87y3T7__"